import React from 'react'
import FrontendLayout from '../FrontendLayout'
import Hero from '../front-components/Hero'
import { ORG } from '../../data/costant'

export default function Restriction() {
  return (
    <FrontendLayout>
      <Hero title="Restrictions on the use of website" />
      <div className="container my-5 card">
        <div className='card-body'>
          <h6>Restrictions on the Use of the Website</h6>

          <ol>
            <li>
              In addition to other restrictions set forth in these Terms of Use, you undertake not to:
              <ol>
                <li>Defame, abuse, harass, threaten or otherwise violate the legal rights of others.</li>
                <li>Publish, post, upload, distribute or disseminate any inappropriate, profane, defamatory, infringing, obscene, indecent or unlawful topic, name, material or information.</li>
                <li>
                  Copy, republish, post, display, translate, transmit, reproduce or distribute any content through any medium without obtaining the necessary authorization from {ORG.web} ({ORG.name}).
                </li>
                <li>Conduct or forward surveys, contests, pyramid schemes or chain letters.</li>
                <li>
                  Upload or distribute files that contain software or other material protected by applicable intellectual property laws unless you own or control the rights thereto or have received all necessary consents.
                </li>
                <li>
                  Upload or distribute files that contain viruses, corrupted files, or any other similar software or programs that may damage the operation of the website or another's computer.
                </li>
                <li>
                  Engage in any activity that interferes with or disrupts access to the website, its contents, or services (or the servers and networks connected to the website).
                </li>
                <li>
                  Attempt to gain unauthorized access to any portion or feature of the website, systems, or networks connected to the website.
                </li>
                <li>
                  Probe, scan, or test the vulnerability of the website or any network connected to it, nor breach security or authentication measures.
                </li>
                <li>
                  Disrupt or interfere with the security of, or otherwise cause harm to, the website, systems resources, accounts, passwords, servers, or networks.
                </li>
                <li>
                  Collect or store data about other users in connection with prohibited conduct and activities.
                </li>
                <li>
                  Use any device or software to interfere with the proper working of the website or any transaction being conducted.
                </li>
                <li>
                  Use the website or its content for any purpose that is unlawful or prohibited by these Terms of Use.
                </li>
                <li>
                  Falsify or delete any author attributions, legal notices, or proprietary designations of the origin or source of content.
                </li>
                <li>
                  Violate any applicable laws, regulations, or rights to privacy or personality.
                </li>
                <li>Reverse engineer, modify, copy, distribute, transmit, display, perform, reproduce, publish, or create derivative works from any information or software obtained from the website.</li>
              </ol>
            </li>
          </ol>

          <h6>Additional Restrictions</h6>
          <ol>
            <li>
              Customers may not:
              <ol>
                <li>Remove any copyright, trademark, or other proprietary notices from any portion of the services.</li>
                <li>
                  Reproduce, modify, prepare derivative works, distribute, license, lease, sell, publicly display, or exploit the website or related services except as expressly permitted by {ORG.web} ({ORG.name}).
                </li>
                <li>
                  Decompile, reverse engineer, or disassemble the website or related services except as permitted by applicable law.
                </li>
                <li>Link to, mirror, or frame any portion of the website or related services.</li>
                <li>
                  Cause or launch any programs or scripts for the purpose of scraping, indexing, or data mining, or unduly burden or hinder the operation of the website.
                </li>
                <li>
                  Attempt to gain unauthorized access to or impair any aspect of the website or its systems or networks.
                </li>
              </ol>
            </li>
            <li>
              {ORG.web} ({ORG.name}) grants customers a non-exclusive, revocable, and non-transferable access to view content on the website under these conditions:
              <ol>
                <li>Content may be accessed solely for personal, informational, and internal purposes in accordance with the Terms of Use.</li>
                <li>Content may not be modified or altered.</li>
                <li>Content may not be distributed, sold, rented, leased, or otherwise made available to others.</li>
                <li>
                  Text, copyright, or other proprietary notices contained in the content must not be removed.
                </li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
    </FrontendLayout>
  )
}
